import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogService } from '../../../shared/services/dialog.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelperService } from '../../../shared/services/helper.service';
import { BreezeService } from '../../../shared/services/breeze.service';
import { ErrorService } from '../../../shared/services/error.service';
import { NotificationService } from 'src/app/shared/services/notification.service';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-login-dialog',
    templateUrl: './login-dialog.component.html',
    styleUrls: ['./login-dialog.component.scss'],
    imports: [
    FormsModule,
    ReactiveFormsModule
]
})
export class LoginDialogComponent implements OnInit {
  hide = true;
  errorMessage: any = '';
  isLoading: boolean = false;
  // recaptchaSiteKey = environment.recaptcha.siteKey;

  constructor(
    private formBuilder: FormBuilder,
    private helperService: HelperService,
    private dialogService: DialogService,
    private breezeService: BreezeService,
    private errorService: ErrorService,
    private readonly notificationService: NotificationService
  ) {}
  private emailRegEx =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  loginForm: FormGroup = new FormGroup({});

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(this.emailRegEx)]],
      password: ['', [Validators.required]],
      // recaptchaToken: ['', [Validators.required]],
    });
    this.breezeService.getIsLoadingListener().subscribe((isLoading) => {
      this.isLoading = isLoading;
      isLoading ? null : this.dialogService.closeLoadingModal();
    });
    this.errorService.getErrorListener().subscribe((errorMessage) => {
      this.errorMessage = errorMessage;
      this.dialogService.closeLoadingModal();
      this.isLoading = false;
    });
  }

  close() {
    this.dialogService.closeLoginModal();
  }

  onForgotPassword() {
    this.dialogService.closeLoginModal();
    this.dialogService.openForgotPasswordDialog();
  }

  onRegister() {
    this.dialogService.closeLoginModal();
    this.dialogService.openSignUpDialog();
  }

  onCaptchaResolved(token: string | null) {
    this.breezeService.verfiyCaptcha(token as string).subscribe((res: any) => {
      this.loginForm.get('recaptchaToken')?.setValue(token as string);
    });
  }

  onLogin() {
    // Validate Form
    if (this.loginForm.invalid) {
      this.helperService.validateAllFormFields(this.loginForm);
      return;
    }
    this.isLoading = true;
    // Handles login request

    // this.breezeService.isAuthListener.subscribe((res) => {
    //   if (res) {
    //     this.notificationService.info('Login Successful')
    //     this.dialogService.closeLoadingModal();
    //     this.dialogService.closeLoginModal();
    //   }
    // });
    this.breezeService.login(this.loginForm.value);
  }
}
